import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { reportSystemIssue } from '../api/endpoints/logs';
import { useAuthStore } from '../auth/authStore';

interface State {
  error: Error | null;
}

/** App-wide React error boundary — shows a recoverable fallback and forwards the crash
 *  to `Logs/ReportSystemIssue` (UNVERIFIED, failures swallowed). */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    void reportSystemIssue({
      sessionId: useAuthStore.getState().session?.sessionId,
      errorTypes: ['react-error-boundary'],
      errorMessages: [error.message, info.componentStack ?? ''].filter(Boolean).slice(0, 2),
      pageUrl: window.location.href,
    }).catch(() => undefined);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Box sx={{ p: 4, maxWidth: 640, mx: 'auto' }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={() => window.location.assign('/')}>
              Anasayfa
            </Button>
          }
        >
          <AlertTitle>Bir hata oluştu</AlertTitle>
          Sayfa yüklenirken beklenmeyen bir sorun çıktı. Sorun ekibimize iletildi.
        </Alert>
      </Box>
    );
  }
}
